export const moduleName = 'UserManagementModule';
